import { render, staticRenderFns } from "./Response.vue?vue&type=template&id=e0970972&scoped=true&"
import script from "../js/response.js?vue&type=script&lang=js&"
export * from "../js/response.js?vue&type=script&lang=js&"
import style0 from "../styles/response.sass?vue&type=style&index=0&id=e0970972&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0970972",
  null
  
)

export default component.exports